<template>
  <div class="question-accordion-component">
    <p class="title">
      {{ title }}
    </p>
    <button
      class="toggle-button"
      aria-label="Expanded content"
      :aria-expanded="expanded"
      @click="toggleExpanded"
    >
      <icon
        class="toggle-icon"
        :class="{ expanded: expanded }"
        name="cross-thin"
        variant="white"
      />
    </button>
    <div
      ref="accordion"
      class="accordion-content"
      :class="{ expanded: expanded, preview: showPreview }"
    >
      <div
        v-if="showPreview && !expanded"
        class="overlay"
      />
      <slot name="before-content" />
      <p
        v-if="content"
        v-html="content"
      />
      <slot name="after-content" />
      <img
        v-for="image in images"
        :key="image.url"
        :src="image.url"
      >
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {Icon},
  props: {
    content: {
      type: String,
    },
    images: {
      type: Array,
    },
    showPreview: {
      type: Boolean,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  mounted() {
    this.$watch('content', (newContent, oldContent) => {
      if (newContent !== oldContent) {
        this.expanded = false;
      }
    });
  },
  methods: {
    toggleExpanded(val) {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-accordion-component {
  .title {
    font-weight: $bold;
    margin: 0 rem-calc(8) 0 0;
    padding: 0;
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .toggle-button {
    display: inline-block;
    background-color: #00d8f8;
    padding: 0;
    width: rem-calc(20);
    height: rem-calc(20);
    border-radius: rem-calc(4);

    .toggle-icon {
      transform: rotate(-45deg);
      transition: .125s linear all;
      width: rem-calc(10);
      margin-bottom: rem-calc(1);

      &.expanded {
        transform: rotate(0deg);
      }
    }
  }

  .accordion-content {
    position: relative;
    overflow: hidden;
    line-height: rem-calc(24);
    height: auto;

    &:not(.expanded) {
      height: 0;
      &.preview {
        height: 52px;
      }
    }

    .overlay {
      background: linear-gradient(rgba(255, 255, 255, 0), rgba(255,255,255, 1));
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 1;
    }
  }
}
</style>
